import { Injectable } from '@angular/core';
import { IdentityModel } from '../models/identity.model';
import { SelfManageService } from './self-manage.service';

@Injectable({
  providedIn: 'root'
})
export class NavbarService {

  visible: boolean;
  identity: IdentityModel;
  language: string;

  constructor(
    private selfManageService: SelfManageService,
  ) { this.visible = false; }

  hide() { this.visible = false; }

  show(enrollmentRoute:boolean) {
    this.visible = true;

    if(this.selfManageService.getLoadedIdentity() == null){
      this.selfManageService.fetchDetails()
      .subscribe(
        resp => {
          this.identity = resp;
        },
        _ => {}
      );
    }
  }

  toggle() { this.visible = !this.visible; }

}
